<template lang="pug">
  div
    v-data-table(
      :headers="service_headers"
      :items="service_list"
    )
</template>

<script>
export default {
  name: "PackageService",
  props: {
    packageId: String,
  },
  watch: {
    packageId() {
      this.getServiceList();
    }
  },
  data() {
    return {
      service_list: [],
      service_headers: [
        { text: "#", value: "service_id", cellClass: "font-weight-bold" },
        { text: "Name", value: "name" },
        { text: "Description", value: "description" },
        { text: "Price", value: "pricing" },
      ],
      loading: false,
    };
  },
  mounted() {
    this.getServiceList();
  },
  methods: {
    getServiceList() {
      const url = "https://saas-api.xendity.com/v1/user/get-service";

      const json = {
        username: this.$store.getters.userName,
        auth_key: this.$store.getters.authKey,
        package_id: this.packageId
      };

      this.loading = true;

      this.$http
        .post(url, json)
        .then((response) => {
          // Success
          try {
            if (response) {
              if (response.body.success == false)
                this.$swal(
                  "Get user package service list failed",
                  response.body.data.message,
                  "error"
                );
              else this.service_list = response.body.data.service_list;
            }
          } catch (error) {
            this.$swal(
              "Get user package service list failed",
              response.body.data.message,
              "error"
            );
          }
        })
        .catch((response) => {
          this.$swal(
            "Get user package service list failed",
            response.body.data.message,
            "error"
          );
        });
    },
  }
};
</script>